import { render } from "./CreateMonster.vue?vue&type=template&id=19909aca"
import script from "./CreateMonster.vue?vue&type=script&lang=js"
export * from "./CreateMonster.vue?vue&type=script&lang=js"
script.render = render

export default script